import type { FC } from 'react';
import React from 'react';
import { FormAutocomplete } from '@components/organisms/forms/form-autocomplete';
import { FormTextField } from '@components/organisms/forms/form-text-field';
import { FormUploadField } from '@components/organisms/forms/form-upload-field';
import { CustomManualFieldType } from '@models';
import { MB_32 } from '@modules/dashboard/pages/docs-verification/docs-verification-page/tabs/personal-data/custom-field/constants';
import type { CustomFieldProps } from '@modules/dashboard/pages/docs-verification/docs-verification-page/tabs/personal-data/custom-field/types';

export const CustomField: FC<CustomFieldProps> = ({ field }) => {
    const name = `custom_fields.${field.index}.value`;

    const { options } = field;
    const labelProps = {
        label: field.label,
    };

    const textFieldProps = {
        fullWidth: true,
        hint: field.caption,
        helperTextStatic: true,
    };

    if (options) {
        if (options.type === CustomManualFieldType.SELECT) {
            return (
                <FormAutocomplete
                    name={name}
                    labelProps={labelProps}
                    options={options.choices.map((choice) => ({
                        value: choice,
                        label: choice,
                    }))}
                    textFieldProps={textFieldProps}
                />
            );
        }

        if (options.type === CustomManualFieldType.FILE) {
            return (
                <FormUploadField
                    name={name}
                    labelProps={labelProps}
                    uploadProps={{
                        maxSize: options.max_size || MB_32,
                        mimeTypes: options.allowed_mime_types,
                    }}
                    textFieldProps={textFieldProps}
                />
            );
        }
    }

    return <FormTextField name={name} labelProps={labelProps} textFieldProps={textFieldProps} />;
};
